const lazyload = require('norska/frontend/lazyload');
lazyload.init();
